export default __webpack_public_path__ + "static/gatsby_TOC_sass_before-a9cddca7ae225db60c6df4ac04ac053f.png";